<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog [modal]="true" [(visible)]="dialogVisible" [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
</p-dialog>
<div>
  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner>
        <style class="custom-spinner"></style>
      </p-progressSpinner>
      <p>{{ processMessage }}</p>
    </div>
  }
  @if (isSuccess) {
    <div>
      <div>
        <h5 style="margin-right: 30%;">
          CCR Orders Not Yet Entered Into SAP as of {{formattedDate }}
        </h5>
      </div>
      <p-toast [baseZIndex]="20000"></p-toast>
      <p-dialog header=" {{ cellValue[0].toUpperCase() }}" [modal]="true" [(visible)]="dialogVisible"
        [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">
      </p-dialog>
      <app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="homeLoadDataColumns"
        [rows$]="homeDataPayLoad$" [pageSize]="10" [totalRecords]="totalRecords"
        (onAction1ButtonClicked)="exportExcel()"
        (onAction2ButtonClicked)="summaryCountRefresh()" [actionButtons]="actionButtons"
        (sortClicked)="onSortClicked($event)" (onSearchText)="onSearchText($event)"
      (pageChanged)="onPageChanged($event)" [rowsPerPageOptions]="[10, 20, 30, 40, 50]"></app-table>
    </div>
  }